import { render, staticRenderFns } from "./StokDetay.vue?vue&type=template&id=6b8fed87&"
import script from "./StokDetay.vue?vue&type=script&lang=js&"
export * from "./StokDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports